import React from 'react';
import { matchPath } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import useMedia from 'utils/hooks/useMedia';
import useRedirect from 'utils/hooks/useRedirect';

import useCurrentLanguage from 'utils/hooks/useCurrentLanguage';
import Navbar from 'react-bulma-components/lib/components/navbar';
import { logUserOutThunk } from '../../../store/entities/auth/thunks';
import { redirectToUserData } from "../../../api/authService";

export default ({ paths }) => {
  const redirect = useRedirect();
  const { t } = useTranslation();
  const language = useCurrentLanguage();
  const { userDetails } = useSelector(state => state.auth);
  const isMobile = useMedia(
      ['(max-width: 1023px)', '(min-width: 1px)'],
      [true, false],
      false
  );

  const dispatch = useDispatch();

  return (
      <>
        {isMobile &&
            paths.map(({ path, defaultPath, label }) => {
              const isActivePath = !!matchPath(window.location.pathname.slice(3), {
                path,
              });
              return (
                  <Navbar.Item className="navbar-item--mobile">
                    <Navbar.Link
                        className={isActivePath ? 'is-active' : ''}
                        aria-pressed={isActivePath}
                        arrowless
                        onClick={() => redirect(defaultPath ?? path[0])}
                    >
                      {label}
                    </Navbar.Link>
                  </Navbar.Item>
              );
            })}
        <div className="navbar-item navbar-item--mobile navbar-item--user">
          <div>
            {userDetails.firstName
                ? `${userDetails?.firstName} ${userDetails?.lastName}`
                : userDetails.username}
          </div>
        </div>
        <Navbar.Item className="navbar-item--mobile">
          <Navbar.Link arrowless onClick={() => redirectToUserData(language)}>
            {t('datagate.external.global.user.profile')}
          </Navbar.Link>
        </Navbar.Item>
        <Navbar.Item className="navbar-item--mobile">
          <Navbar.Link arrowless onClick={() => dispatch(logUserOutThunk())}>
            {t('datagate.external.global.logOut')}
          </Navbar.Link>
        </Navbar.Item>
        <div className="mobile-navbar-socials">
          <stat-ee-header-social
              data-app="portaal"
              data-lang={language || 'et'}
              data-style="white"
          ></stat-ee-header-social>
        </div>
      </>
  );
};
